import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import MellowIllustration from '@/components/MellowIllustration';
import PageMeta from '@/components/PageMeta';
import Card from '@/ds-components/Card';

import styles from './index.module.scss';

type Props = {
  readonly className?: string;
};

function NotFound({ className }: Props) {
  const { t } = useTranslation(undefined, { keyPrefix: 'admin_console' });

  return (
    <div className={classNames(styles.container, className)}>
      {/* Don't track "not found" for the root path as it will be redirected. */}
      <PageMeta titleKey="errors.page_not_found" />
      <Card className={styles.content}>
        <MellowIllustration scene="activity" />
        <div className={styles.message}>{t('errors.page_not_found')}</div>
      </Card>
    </div>
  );
}

export default NotFound;
